import {
  ITextJoinBehavior,
  IItemSelectTriggerBehaviorSpecifiable, instanceOfIItemSelectTriggerBehaviorSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { ICalculatableObject, instanceOfICalculatableObject } from "./ICalculatableObject";

export interface IJoinTextObject extends ICalculatableObject, IItemSelectTriggerBehaviorSpecifiable {
  textJoinBehavior: ITextJoinBehavior;
}

export function instanceOfIJoinTextObject(instance: any): instance is IJoinTextObject {
  return instance
      && (instance.textJoinBehavior !== undefined)
      && instanceOfIItemSelectTriggerBehaviorSpecifiable(instance)
      && instanceOfICalculatableObject<IJoinTextObject>(instance, "jointext");
}
